<template>
    <div class="list-live" v-if="!!params.list_live && params.list_live.length>0">
        <div class="media-title" v-if="params.title_box">
            <div class="title-txt">
                {{params.title}}
            </div>
            <div class="title-more" @click="onClick(params.link)" v-if="params.more_box">
                {{params.more}}
            </div>
        </div>
        <div class="live-content">
            <div class="content-li" v-for="(item,index) in params.list_live" :key="index"  @click="onClick(item.link)" v-if="index < params.max_cnt">
                <div class="content-img">
                    <van-image
                            width="100%"
                            height="100%"
                            fit="cover"
                            :src="item.info.cover_url"
                            radius="5"
                    />
                    <div class="content-info-view">
                        <span class="iconfont iconchakan"></span>
                        {{item.info.view_count}}
                    </div>
                </div>
                <div class="content">
                    <div class="content-title">
                        {{item.info.name}}
                    </div>
                    <div class="content-lecturer">
                        {{item.info.desc}}
                    </div>
                    <div class="content-info">
                        <div class="content-info-play-time">
                            {{item.info.lecturer}}
                        </div>
                        <div class="content-info-play-money">
                            {{item.info.money*1==0 ?'免费':'￥'+(item.info.money*1)}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Image as VanImage } from 'vant';
    export default {
        name: "list_live",
        props:{
            params: Object
        },
        components:{
          [VanImage.name]:VanImage
        },
        methods: {
            onClick(link) {
                // this.util.carouselUrl(link);
                if(!!link){
                    this.$router.push(link);
                }
            },
        },
    }
</script>

<style scoped>
    .content-img .content-info-view{
        position: absolute;
        font-size: 10px;
        color: #ffffff;
        top: -3px;
        left: -3px;
        margin: 6px;
        padding: 2px 6px;
        background: rgba(0,0,0,0.4);
        border-radius: 8px;
        transform: scale(0.8);
    }
    .content-info-view .iconfont{
        font-size: 10px;
    }
    .list-live{
        width: 100%;
        margin: 10px 0;
    }
    .list-live .media-title{
        background-color: #fff;
    }
    .list-live .media-title .title-txt,.list-live .media-title .title-more{
        display: inline-block;
        vertical-align: middle;
    }
    .list-live .media-title .title-txt{
        max-width: 80%;
        font-size: 16px;
        font-weight: bold;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        color: #171717;
    }
    .list-live .media-title .title-more{
        float: right;
        color: #327CE9;
        font-size: 12px;
        margin-top: 2px;
    }
    .list-live .live-title{
        padding: 10px;
        background-color: #fff;
    }
    .list-live .live-title .title-txt,.list-live .live-title .title-more{
        display: inline-block;
        vertical-align: middle;
    }
    .list-live .live-title .title-txt{
        max-width: 80%;
        font-size: 16px;
        font-weight: bold;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .list-live .live-title .title-more{
        float: right;
        font-weight: bold;
        color: #327CE9;
    }
    .list-live .live-content{
        width: 100%;
        background-color: #fff;
    }
    .list-live .content-li{
        width: 100%;
        margin: 10px 0;
        position: relative;
        display: flex;
        flex-wrap: wrap;
    }
    .list-live .content-li .content-img{
        height: 101px;
        width: 135px;
        display: flex;
        font-size: 0;
    }
    .list-live .content{
        padding-left: 8px;
        flex: 1;
    }

    .list-live .content-info{
        display: flex;
        line-height: 16px;
    }
    .list-live .content-li .content-title{
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        color: #171717;
        font-weight:500;
        height: 40px;
        line-height: 20px;
    }
    .list-live .content-li .content-info-play-time{
        font-size: 12px;
        color: #999999;
        flex: 1;
    }
    .list-live .content-info-type{
        position: absolute;
        top: 0;
        right: 0;
        margin: 3px;
        padding: 2px 6px;
        font-size: 10px;
        color: #ffffff;
        background: rgba(0,0,0,0.4);
        border-radius: 5px;
    }
    .list-live .content-lecturer{
        overflow: hidden;
        color: #999999;
        margin-top: 8px;
        margin-bottom: 15px;
        font-size: 12px;
        height: 17px;
        width: 100%;
        display: flex;
    }
    .list-live .content-info-play-money{
        font-size: 12px;
        color: #FF624F;
    }
</style>
